module.exports = {
  COMMON_JS_SEARCH_QUERY_GENERIC: 'q',
};
